// src/api/adminService.ts
import axios from 'axios';

// Detectar automáticamente el entorno
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_URL = isDevelopment 
  ? 'http://localhost:8000' 
  : (process.env.REACT_APP_API_URL || 'https://german-mallo-chatbot-api-127932552526.herokuapp.com');

console.log('API_URL configurada:', API_URL);

// Helper para obtener las credenciales del localStorage
const getAuthHeader = () => {
  const username = localStorage.getItem('adminUsername') || 'germanmallo04';
  const password = localStorage.getItem('adminPassword') || '44927333@#Ff';
  return `Basic ${btoa(`${username}:${password}`)}`;
};

export const getDocuments = async () => {
  try {
    const response = await axios.get(`${API_URL}/admin/documents/list`, {
      headers: {
        'Authorization': getAuthHeader()
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error getting documents:', error);
    throw error;
  }
};

export const getDocument = async (docId: string) => {
  try {
    const response = await axios.get(`${API_URL}/admin/documents/get/${docId}`, {
      headers: {
        'Authorization': getAuthHeader()
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error getting document:', error);
    throw error;
  }
};

export const createDocument = async (data: { title: string; content: string; author?: string; source?: string }) => {
  try {
    const response = await axios.post(`${API_URL}/admin/documents/create`, data, {
      headers: {
        'Authorization': getAuthHeader(),
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating document:', error);
    throw error;
  }
};

export const updateDocument = async (docId: string, data: { content: string; author?: string; source?: string }) => {
  try {
    const response = await axios.put(`${API_URL}/admin/documents/update/${docId}`, data, {
      headers: {
        'Authorization': getAuthHeader(),
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating document:', error);
    throw error;
  }
};

export const deleteDocument = async (docId: string) => {
  try {
    const response = await axios.delete(`${API_URL}/admin/documents/delete/${docId}`, {
      headers: {
        'Authorization': getAuthHeader()
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting document:', error);
    throw error;
  }
};

export const uploadDocument = async (file: File, title: string, author: string, source: string, username: string, password: string) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('title', title);
    formData.append('author', author);
    formData.append('source', source);

    const response = await axios.post(`${API_URL}/admin/documents/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Basic ${btoa(`${username}:${password}`)}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading document:', error);
    throw error;
  }
};